// @flow
import * as React from 'react';

// Utils
import { textToHTML } from 'utils/string';

type Props = {|
  html?: string,
  useHelper: boolean
|};

export default function ParseHTML({ html, useHelper, ...others }: Props) {
  const htmlString = html || '';
  return (
    <div
      aria-modal={true}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: useHelper ? textToHTML(htmlString) : htmlString
      }}
      {...others}
    />
  );
}

ParseHTML.defaultProps = {
  useHelper: true
};



// WEBPACK FOOTER //
// ./src/components/atoms/ParseHTML/ParseHTML.js